import { createStore } from 'cross-state';

export const navigationOpen = createStore(document.body.offsetWidth > 599);

export const toggleNavigation = (force?: boolean) => navigationOpen.set((open) => force ?? !open);
